import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";

function BackButton() {
    const navigate = useNavigate();
    return (
        <div
            style={{
                zIndex: "100",
            }}
        >
            <IconButton
                sx={{
                    backgroundColor: "white",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                }}
                color="white"
                variant="filled"
                aria-label="go back"
                onClick={() => {
                    navigate(-1);
                }}
            >
                <ArrowBackIosNewIcon sx={{ color: "#202020", paddingRight: '4px' }} />
            </IconButton>
        </div>
    );
}

export default BackButton;
